import { fetchUserAttributes, updateUserAttributes } from 'aws-amplify/auth';
import { createAppAsyncThunk } from '../appAsyncThunk';
import { downloadData } from 'aws-amplify/storage';
import { get, post, ApiError } from 'aws-amplify/api';
import { setNotification } from '../general/slice';
import { setIncompleteProfileModal, setIncompleteProfileType } from './slice';

export const getProfileDataThunk = createAppAsyncThunk(
    'signUp/getProfileDataThunk', async (_, { dispatch }) => {
        try {
            const restOperation = await get({
                apiName: 'profile',
                path: '/profile/{proxy+}',
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (error: unknown) {
            if (error instanceof ApiError) {
                if (error.response && error.response.statusCode === 405) {
                    const { body } = error.response;
                    if (body) {
                        const bodyObj = JSON.parse(body);
                        if ('profile' in bodyObj && bodyObj.profile === 'inComplete') {
                            dispatch(setIncompleteProfileModal(true));
                            dispatch(setIncompleteProfileType('Profile'));
                        }

                        if ('cognito' in bodyObj) {
                            dispatch(setIncompleteProfileModal(true));
                            dispatch(setIncompleteProfileType('Cognito'));
                        }
                    }
                }
            }
        }
    });

export const getAvatarPhotoThunk = createAppAsyncThunk(
    'dashboard/getAvatarPhotoThunk', async (key: string) => {
        const downloadResult = await downloadData({
            key,
            options: {
                accessLevel: 'private',
            }
        }).result;

        const blob = await downloadResult.body.blob();
        const ObjectURL = URL.createObjectURL(blob);
        return ObjectURL;
    });

export const getFacePhotoThunk = createAppAsyncThunk(
    'dashboard/getFacePhotoThunk', async (key: string) => {
        const downloadResult = await downloadData({
            key,
            options: {
                accessLevel: 'private',
            }
        }).result;

        const blob = await downloadResult.body.blob();
        const ObjectURL = URL.createObjectURL(blob);
        return ObjectURL;
    });

export const getUserAttributesThunk = createAppAsyncThunk(
    'dashboard/getUserAttributesThunk', async () => {
        const userAttributes = await fetchUserAttributes();
        return userAttributes;
    });

export const getMatchedJobsThunk = createAppAsyncThunk(
    'dashboard/getMatchedJobsThunk', async (id: string, { rejectWithValue }) => {
        try {
            const restOperation = await get({
                apiName: 'matchedJobs',
                path: '/matchedJobs/{proxy+}',
                options: { queryParams: { id } }
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Error');
        }
    });

export const getJobDetailThunk = createAppAsyncThunk(
    'dashboard/getJobDetailThunk', async (body: any, { rejectWithValue }) => {
        try {
            const restOperation = await post({
                apiName: 'matchedJobs',
                path: '/matchedJobs/{proxy+}',
                options: { body }
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('Error');
        }
    });

export const getExamsHistoryThunk = createAppAsyncThunk(
    'dashboard/getExamsHistoryThunk', async (id: string, { rejectWithValue }) => {
        try {
            const restOperation = await get({
                apiName: 'pastExam',
                path: '/pastExam/{proxy+}',
                options: { queryParams: { id } },
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('An error occurred, Try again later');
        }
    });

export const sendSupportMessageThunk = createAppAsyncThunk(
    'workspace/sendSupportMessageThunk', async (body: any, { dispatch, rejectWithValue }) => {
        try {
            const restOperation = post({
                apiName: 'support',
                path: '/support/{proxy+}',
                options: { body }
            });

            const response = await restOperation.response;
            dispatch(setNotification(['Message sent successfully', 'success']));
            return response.body.json();
        } catch (e: unknown) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const setSettingsThunk = createAppAsyncThunk(
    'workspace/setSettingsThunk', async (body: any, { dispatch, rejectWithValue }) => {
        try {
            const restOperation = post({
                apiName: 'setting',
                path: '/setting/{proxy+}',
                options: { body }
            });

            const response = await restOperation.response;
            dispatch(setNotification(['Settings saved successfully', 'success']));
            dispatch(getProfileDataThunk());
            // dispatch(getProfileDataThunk(body?.userId));
            return response.body.json();
        } catch (e: unknown) {
            return rejectWithValue('Something went wrong,Try again...');
        }
    });

export const updatePersonalInformationThunk = createAppAsyncThunk(
    'workspace/updatePersonalInformationThunk', async (userAttributes: any, { dispatch, rejectWithValue }) => {
        try {
            const response = await updateUserAttributes({
                userAttributes: {
                    email: userAttributes.email,
                    address: userAttributes.address,
                    birthdate: userAttributes.birthDate,
                    family_name: userAttributes.lastName,
                    given_name: userAttributes.firstName,
                    phone_number: userAttributes.phoneNumber,
                    'custom:city': userAttributes.city,
                    'custom:state': userAttributes.state,
                    'custom:zipCode': userAttributes.zipCode,
                    'custom:country': userAttributes.country,
                    'custom:firstName': userAttributes.firstName,
                    'custom:linkedinLink': userAttributes.linkedinLink,
                    'custom:preferredName': userAttributes.preferredName,
                }
            });

            dispatch(getUserAttributesThunk());
            return response;
        } catch (e: unknown) {
            if (e instanceof Error) {
                return rejectWithValue(e.message);
            } else {
                return rejectWithValue('Somthing went wrong. Please try again');
            }
        }
    });


export const updateProfileDataThunk = createAppAsyncThunk(
    'workspace/updateProfileDataThunk', async (body: any, { dispatch, rejectWithValue }) => {
        try {

            const restOperation = post({
                apiName: 'profile',
                path: '/profile/{proxy+}',
                options: { body }
            });

            const response = await restOperation.response;
            dispatch(getProfileDataThunk());
            // dispatch(getProfileDataThunk(body.id));
            return response.body.json();
        } catch (e: unknown) {
            if (e instanceof Error) {
                return rejectWithValue(e.message);
            } else {
                return rejectWithValue('Somthing went wrong. Please try again');
            }
        }
    });

export const getUrlThunk = createAppAsyncThunk(
    'workspace/getUrlThunk', async (body: any) => {
        try {
            const restOperation = post({
                apiName: 'getUrl',
                path: '/getUrl/{proxy+}',
                options: { body }
            });

            const response = await restOperation.response;
            const json = await response.body.json() as any;
            return json ? json.url : ''
        } catch (e: unknown) {
            console.log('Error on fetch logo');
        }
    });
